import { createSimulationWithGrid } from '../game/simulation'
import type { SimulationState } from '../game/types'
import type { RoomPlayer } from './protocol'

export interface MultiplayerGridEntry extends RoomPlayer {
  vehicleId: string
  local: boolean
}

export function createMultiplayerGrid(players: RoomPlayer[], localClientId: string): MultiplayerGridEntry[] {
  const unique = new Map<string, RoomPlayer>()
  for (const player of [...players].sort((a, b) => a.joinedAt - b.joinedAt)) {
    if (!unique.has(player.clientId)) unique.set(player.clientId, player)
    if (unique.size === 8) break
  }
  const ordered = [...unique.values()]
  const local = ordered.find((player) => player.clientId === localClientId)
  if (!local) return []
  let rivalIndex = 1
  return ordered.map((player) => ({
    ...player,
    local: player.clientId === localClientId,
    vehicleId: player.clientId === localClientId ? 'player' : `rival-${rivalIndex++}`,
  }))
}

export function createMultiplayerSimulation(players: RoomPlayer[], localClientId: string): SimulationState {
  const grid = createMultiplayerGrid(players, localClientId)
  return createSimulationWithGrid(
    grid.map((entry) => ({
      id: entry.vehicleId,
      kind: entry.local ? 'player' : 'remote',
      displayName: entry.nickname,
    })),
    'server',
  )
}

export function clientIdForVehicle(grid: MultiplayerGridEntry[], vehicleId: string): string | null {
  return grid.find((entry) => entry.vehicleId === vehicleId)?.clientId ?? null
}

export function vehicleIdForClient(grid: MultiplayerGridEntry[], clientId: string): string | null {
  return grid.find((entry) => entry.clientId === clientId)?.vehicleId ?? null
}
